<template>
  <li class="basket-item">
    <div class="basket-item__image image_library">
      <img :src="content.Thumbnail">
    </div>
    <div class="basket-item__content">
      {{content.Name}}
      <div class="basket-item__actions">
        <div class="checkbox">
          <input type="checkbox" :id="'basket'+_uid" v-model="content.selected" @change="updateItem(content, content.selected)"><label :for="'basket'+_uid" class="tick-green">Select: </label>
        </div>
        <button class="icon-button document__actions__button trash-green" v-on:click="deleteItem(content.Id)"></button>
      </div>
    </div>
  </li>
</template>

<script>
  import { deleteItem, updateItem } from "./BasketActions";
  export default {
    props: ["content"],
    vuex: {
      actions: { deleteItem, updateItem }
    }
  };
</script>


<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .basket-item{
    float: left;
    width: 50%;
    margin-bottom: 50px;

    &__image{
      position: relative;
      float: left;
      min-width: 220px;
      max-width: 220px;
      min-height: 316px;
      border: 1px solid $green_dark;

      &:after{
        content: "";
        display: block;
        width: 48px;
        height: 48px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -24px;
        margin-top: -24px;
        opacity: 0.3;
      }

      img{
        width: 100%;
        display: block;
        position: relative;
        z-index: 2;
      }
    }

    &__content{
      line-height: 24px;
      padding: 20px 40px 0 40px;
      float: left;
      width: 275px;
      box-sizing: border-box;
      color: $white;
    }

    &__actions{
      margin-top: 25px;

      &__button{
        margin-right: 11px;
      }

      &__select{
        width: 180px;
        margin-bottom: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// BasketListItem.vue?7e1b7ad2